<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiViewDashboardVariantOutline } from "@mdi/js"

export default {
  name: "ViewDashboardVariantOutlineIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
        path: mdiViewDashboardVariantOutline,
    }
  }
}
</script>
